var map = {
	"./agua_bruta.svg": "./src/assets/icons/buildings/agua_bruta.svg",
	"./agua_bruta_piso_3.svg": "./src/assets/icons/buildings/agua_bruta_piso_3.svg",
	"./agua_global.svg": "./src/assets/icons/buildings/agua_global.svg",
	"./agua_potavel.svg": "./src/assets/icons/buildings/agua_potavel.svg",
	"./agua_potavel_piso_3.svg": "./src/assets/icons/buildings/agua_potavel_piso_3.svg",
	"./consumo_termino.svg": "./src/assets/icons/buildings/consumo_termino.svg?c0a2",
	"./custo_agua_piso_3.svg": "./src/assets/icons/buildings/custo_agua_piso_3.svg",
	"./eletric.svg": "./src/assets/icons/buildings/eletric.svg?3a0b",
	"./euro.svg": "./src/assets/icons/buildings/euro.svg?7fa8",
	"./gas.svg": "./src/assets/icons/buildings/gas.svg?ffbb",
	"./humidade_norte.svg": "./src/assets/icons/buildings/humidade_norte.svg",
	"./humidade_sul.svg": "./src/assets/icons/buildings/humidade_sul.svg",
	"./occupation/annual.svg": "./src/assets/icons/buildings/occupation/annual.svg",
	"./occupation/buildings-2.svg": "./src/assets/icons/buildings/occupation/buildings-2.svg",
	"./occupation/calendar-2.svg": "./src/assets/icons/buildings/occupation/calendar-2.svg",
	"./occupation/company.svg": "./src/assets/icons/buildings/occupation/company.svg",
	"./occupation/enter.svg": "./src/assets/icons/buildings/occupation/enter.svg",
	"./occupation/logout-2.svg": "./src/assets/icons/buildings/occupation/logout-2.svg",
	"./statistics/instalacao_sanitaria.svg": "./src/assets/icons/buildings/statistics/instalacao_sanitaria.svg",
	"./statistics/numero_contadores_agua.svg": "./src/assets/icons/buildings/statistics/numero_contadores_agua.svg",
	"./statistics/numero_contadores_eletricidade.svg": "./src/assets/icons/buildings/statistics/numero_contadores_eletricidade.svg",
	"./statistics/numero_contadores_gas.svg": "./src/assets/icons/buildings/statistics/numero_contadores_gas.svg",
	"./statistics/numero_total_ocorrencias.svg": "./src/assets/icons/buildings/statistics/numero_total_ocorrencias.svg",
	"./statistics/numero_total_ocorrencias_curso.svg": "./src/assets/icons/buildings/statistics/numero_total_ocorrencias_curso.svg",
	"./statistics/numero_total_trabalhos_concluidos.svg": "./src/assets/icons/buildings/statistics/numero_total_trabalhos_concluidos.svg",
	"./statistics/numero_total_trabalhos_planeados.svg": "./src/assets/icons/buildings/statistics/numero_total_trabalhos_planeados.svg",
	"./statistics/total_hattes.svg": "./src/assets/icons/buildings/statistics/total_hattes.svg",
	"./statistics/unidade_tratamento_ar.svg": "./src/assets/icons/buildings/statistics/unidade_tratamento_ar.svg",
	"./temperatura_norte.svg": "./src/assets/icons/buildings/temperatura_norte.svg",
	"./temperatura_sul.svg": "./src/assets/icons/buildings/temperatura_sul.svg",
	"./water-icon.svg": "./src/assets/icons/buildings/water-icon.svg?f57e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/buildings sync recursive ^\\.\\/.*$";